import React from 'react';

import Button, { BUTTON_COLORS, BUTTON_VARIANTS } from 'js/src/components/common/ui/Button';

type Props = {
    onClick: () => void;
};
const PauseRecordingButton: React.FC<Props> = ({ onClick }) => {
    return (
        <Button
            text="Pause"
            color={BUTTON_COLORS.TERTIARY}
            variant={BUTTON_VARIANTS.OUTLINE}
            iconLeft="pause"
            onClick={onClick}
            tooltipContainer=".controls"
            tooltipTitle="You can press spacebar to pause or resume recording."
            className="me-l5-16"
        />
    );
};
export default React.memo(PauseRecordingButton);
